module.exports = __webpack_public_path__ + "img/company.75f5bce9.svg";